/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/scope */
import React, { useState, useEffect } from 'react'
import Footer from "../../Common/Footer";
import { TbPlayerPlay } from 'react-icons/tb';
import { FaPlus } from 'react-icons/fa6';
import IMG from "../../../Images/widgets/web-form1.svg"
import IMG1 from "../../../Images/widgets/web-form2.svg"
import IMG2 from "../../../Images/widgets/web-form3.svg"
import IMG3 from "../../../Images/widgets/web-form4.svg"
import IMG4 from "../../../Images/widgets/LeadBooster_video.svg"
import { useNavigate } from "react-router-dom";
import { Navigation, Pagination as SwiperPagination, Scrollbar, A11y } from 'swiper/modules';
import Loading from "../../Common/Loading"
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BiEdit, BiPowerOff } from 'react-icons/bi';
import { MdContentCopy, MdDeleteForever } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoSearch } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveDeActiveWebForm, getAllGridWebForms, getDeleteWebForm, getDuplicateWebForm, } from '../../../Redux/WebFormSlice';
import { ACTIVE_DEACTIVE_WEBFORM, DELETE_WEBFORM, DUPLICATE_WEBFORM, GET_ALL_GRID_WEBFORMS, } from '../../Common/API';
import sweetAlert from '../../Common/sweetAlert';
import { formatDate, PageNumber } from '../../Common/Common';
import CrmPagination from "../../Common/Pagination";


const WebForms = ({ isVisible, setIsVisible, setSidebarOpen, sidebarOpen, isDark, setIsDark }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.root.auth);
  const authToken = `Bearer ${token}`;
  const [allWebForm, setAllWebForm] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = allWebForm?.slice(indexOfFirstRow, indexOfLastRow)
  const totalPages = Math?.ceil(allWebForm?.length / rowsPerPage);


  useEffect(() => {
    fetchWebForm()
  }, [])

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const fetchWebForm = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${GET_ALL_GRID_WEBFORMS}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    };

    dispatch(getAllGridWebForms({ config })).then((res) => {
      setAllWebForm(res?.payload?.data)
      const timer = setTimeout(() => {
        setLoading(false)
      }, 1000);

      return () => clearTimeout(timer);
    }).catch((error) => {
      console.log('error', error)
      setLoading(false)
    })
  }



  const handleEditWebForm = (Item) => {
    navigate(`/WebForms/createForm/${Item?.webFromMasterID}`, {
      state: { selectForm: "", },
    })
  }

  const handleDeleteWebForm = async (Item) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${DELETE_WEBFORM}?WebFromMasterIDs=${Item?.webFromMasterID}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    };
    try {
      const result = await sweetAlert.confirm('Are you sure?', 'Are you sure you want to delete this!');
      if (result.isConfirmed) {
        dispatch(getDeleteWebForm({ config })).then((res) => {
          fetchWebForm()
          sweetAlert.success('Deleted successfully');
        })
      }
    } catch (error) {
      console.error('Error:', error);
      sweetAlert.error('An error occurred');
    }
  }

  const handleDuplicateWebForm = (Item) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${DUPLICATE_WEBFORM}?WebFromMasterID=${Item?.webFromMasterID}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    };

    dispatch(getDuplicateWebForm({ config })).then((res) => {
      fetchWebForm()
    }).catch((error) => {
      console.log('error', error)
    })
  }

  const handleDeactiveWebForm = (Item) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${ACTIVE_DEACTIVE_WEBFORM}?WebFromMasterID=${Item?.webFromMasterID}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    };

    dispatch(getActiveDeActiveWebForm({ config })).then((res) => {
      fetchWebForm()
    }).catch((error) => {
      console.log('error', error)
    })
  }

  const totalWebForms = allWebForm?.length || 0;
  const activeWebForms = allWebForm?.filter(w => w?.isActive).length || 0;
  const inactiveWebForms = allWebForm?.filter(w => !w?.isActive).length || 0;
  const totalViews = allWebForm?.reduce((sum, w) => sum + (w?.viewed || 0), 0) || 0;
  const totalInteracted = allWebForm?.reduce((sum, w) => sum + (w?.interacted || 0), 0) || 0;
  const totalConversion = allWebForm?.length ? (allWebForm?.reduce((sum, w) => sum + (w?.conversion || 0), 0) / allWebForm?.length).toFixed(1) : 0;

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] h-full px-4 pt-[54px] duration-300">
          <div className="h-full">
            {loading && (
              <div className="h-screen"><Loading /></div>
            )}
            {!loading && (
              <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">
                
                {/* Page Header */}
                <div className="crm-page-header">
                  <div className="flex items-center justify-between">
                    <div>
                      <h1 className="crm-page-title">Web Forms</h1>
                      <ol className="crm-breadcrumb">
                        <li><a href="/Analytics">Disploy</a></li>
                        <li>/</li>
                        <li>Leads</li>
                        <li>/</li>
                        <li className="active">Web Forms</li>
                      </ol>
                    </div>
                    <button className="crm-new-btn" onClick={() => navigate("/WebForms/Addwebform")}>
                      <FaPlus size={11} />
                      New Web Form
                    </button>
                  </div>
                </div>

                {/* Stat Cards */}
                <div className="crm-stats-row">
                  <div className="crm-stat-card crm-card-indigo">
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-indigo">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                          <path d="M21 12H3M12 3v18" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Total Forms</p>
                        <p className="stat-value">{totalWebForms}</p>
                        <p className="stat-trend-up">↑ 4% vs last month</p>
                      </div>
                    </div>
                  </div>
                  <div className="crm-stat-card crm-card-green">
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-green">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 6 12 12 16 14" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Active Forms</p>
                        <p className="stat-value">{activeWebForms}</p>
                        <p className="stat-trend-up">↑ 6% vs last month</p>
                      </div>
                    </div>
                  </div>
                  <div className="crm-stat-card crm-card-red">
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-red">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Inactive Forms</p>
                        <p className="stat-value">{inactiveWebForms}</p>
                        <p className="stat-trend-down">↓ 2% vs last month</p>
                      </div>
                    </div>
                  </div>
                  <div className="crm-stat-card crm-card-blue">
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-blue">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Total Views</p>
                        <p className="stat-value">{totalViews}</p>
                        <p className="stat-trend-up">↑ 18% vs last month</p>
                      </div>
                    </div>
                  </div>
                  <div className="crm-stat-card crm-card-purple" style={{ borderTop: '4px solid #a855f7' }}>
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-purple" style={{ color: '#a855f7', background: '#f3e8ff' }}>
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Interacted</p>
                        <p className="stat-value">{totalInteracted}</p>
                        <p className="stat-trend-up">↑ 12% vs last month</p>
                      </div>
                    </div>
                  </div>
                  <div className="crm-stat-card crm-card-sky">
                    <div className="flex items-start gap-3">
                      <div className="stat-icon stat-icon-sky">
                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                          <polyline points="17 6 23 6 23 12" />
                        </svg>
                      </div>
                      <div>
                        <p className="stat-label">Avg Conversion</p>
                        <p className="stat-value">{totalConversion}%</p>
                        <p className="stat-trend-up">↑ 3% vs last month</p>
                      </div>
                    </div>
                  </div>
                </div>

                {(allWebForm?.length === 0 || allWebForm === null) ? (
                  <div className="crm-panel p-5">
                    <div className="text-center py-3 px-4 dark:text-slate-300/70 relative">
                      <h4 className="font-medium text-3xl">Web Forms</h4>
                      <p className="mb-4">Ensure your leads’ vital data is captured with intuitive forms that are easy to share.</p>
                      <p>
                        <a
                          onClick={() => navigate("/WebForms/Addwebform")}
                          className="focus:outline-none cursor-pointer text-white bg-green-500 hover:bg-green-600 font-medium rounded-full text-lg px-5 py-2 dark:bg-green-500 dark:hover:bg-green-600 mb-4 inline-flex items-center"
                        >
                          <FaPlus className="text-3xl mr-2" />Try Web Forms
                        </a>
                      </p>
                    </div>
                    <div className="bg-white dark:bg-slate-800 w-full relative p-3 h-full text-center sm:mx-auto lg:max-w-4xl">
                      <Swiper
                        modules={[Navigation, SwiperPagination, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                      >
                        <SwiperSlide>
                          <div className="swiper-slide flex justify-center">
                            <img src={IMG} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="swiper-slide flex justify-center">
                            <img src={IMG1} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="swiper-slide flex justify-center">
                            <img src={IMG2} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="swiper-slide flex justify-center">
                            <img src={IMG3} alt="" />
                          </div>
                        </SwiperSlide>
                      </Swiper>
                      <div className="flex-auto p-4">
                        <a href="#watch_video_pop" className="px-5 py-3 text-xl font-medium text-gray-900 focus:outline-none bg-white rounded border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mb-4">Watch video (31:10)</a>
                      </div>

                      <div className="border-b border-solid border-slate-200 dark:border-slate-700 py-3 px-4 dark:text-slate-300/70 mb-5">
                        <div className="flex-auto p-4">
                          <h3 className="font-medium text-3xl mb-4">Get more leads with LeadBooster</h3>
                          <a href="#watch_video_pop" className="relative inline-block h-full">
                            <img src={IMG4} alt="existing-leads" className="inline-block" />
                            <span className="absolute w-20 h-20 top-1/2 left-1/2 rounded-full bg-red-500 flex items-center justify-center -ml-10 -mt-10">
                              <TbPlayerPlay className="text-white text-4xl" />
                            </span>
                            <span className="absolute right-3 bottom-4 p-2 bg-white text-slate-700 text-[11px] font-medium mr-1 px-2.5 py-0.5 rounded shadow-sm">01:43</span>
                          </a>
                          <p className="my-4"><a href="#" className="text-blue-600 text-xl"> Learn More</a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="crm-panel">
                    <div className="relative scroll-inner">
                      <table className="crm-table">
                        <thead>
                          <tr>
                            <th scope="col" className="p-4 text-left">
                              Web forms
                            </th>
                            <th scope="col" className="p-4">
                              Viewed
                            </th>
                            <th scope="col" className="p-4">
                              Interacted
                            </th>
                            <th scope="col" className="p-4">
                              Submitted
                            </th>
                            <th scope="col" className="p-4">
                              Conversion
                            </th>
                            <th scope="col" className="p-4">
                              Status
                            </th>
                            <th scope="col" className="p-4">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRows?.length > 0 ? (
                            currentRows?.map((item, index, arr) => {
                              const showUpward = index >= arr.length - 2 && arr.length > 1;
                              return (
                               <tr key={index} className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-left">
                                <td className="p-4 font-medium text-slate-800 whitespace-nowrap text-left" onClick={() => handleEditWebForm(item)}>
                                  <div>
                                    <div className="mb-1 text-sm font-semibold text-indigo-600 hover:text-indigo-800 cursor-pointer">
                                      {item?.name}
                                    </div>
                                    <div className="flex flex-row gap-2 items-center text-xs text-slate-500">
                                      <span>{item?.userName}</span>
                                      <span>Created on {formatDate(item?.createdDate)}</span>
                                    </div>
                                  </div>
                                </td>
                                <td className="p-4 capitalize text-sm text-slate-600" onClick={() => handleEditWebForm(item)}>
                                  {item?.viewed}
                                </td>
                                <td className="p-4 capitalize text-sm text-slate-600" onClick={() => handleEditWebForm(item)}>
                                  {item?.interacted}
                                </td>
                                <td className="p-4 capitalize text-sm text-slate-600" onClick={() => handleEditWebForm(item)}>
                                  0
                                </td>
                                <td className="p-4 capitalize text-sm text-slate-600 font-semibold" onClick={() => handleEditWebForm(item)}>
                                  {item?.conversion}%
                                </td>
                                <td className="p-4 capitalize text-sm" onClick={() => handleEditWebForm(item)}>
                      <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${item?.isActive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                                    {item?.isActive ? 'ACTIVE' : 'INACTIVE'}
                                  </span>
                                </td>
                                <td className="p-4 text-left whitespace-nowrap">
                                  <div className="relative inline-block text-left">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenActionMenuId(openActionMenuId === item.webFromMasterID ? null : item.webFromMasterID);
                                      }}
                                      className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors text-left"
                                    >
                                      <BsThreeDotsVertical size={16} />
                                    </button>
                                    {openActionMenuId === item.webFromMasterID && (
                                      <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEditWebForm(item);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <BiEdit size={14} className="text-indigo-500" />
                                          <span>Edit</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDuplicateWebForm(item);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <MdContentCopy size={14} className="text-indigo-500" />
                                          <span>Copy</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeactiveWebForm(item);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <BiPowerOff size={14} className="text-indigo-500" />
                                          <span>{item?.isActive ? 'Deactivate' : 'Activate'}</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteWebForm(item);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors text-left"
                                        >
                                          <MdDeleteForever size={14} className="text-red-500" />
                                          <span>Delete</span>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ); })
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-4 text-slate-500">
                                Not Found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <CrmPagination
                      handlePageChange={handlePageChange}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      sidebarOpen={sidebarOpen}
                      totalPages={totalPages}
                      length={allWebForm?.length}
                      setrowsPerPage={setrowsPerPage}
                      rowsPerPage={rowsPerPage}
                      name="Web Forms"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WebForms

